var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isUserAllowedInLevel5or6)?_c('div',[(_vm.isUserAllowedInLevel5or6)?_c('div',[_c('RentalCarPricingRepairShop')],1):_vm._e()]):_c('Forbidden')
}
var staticRenderFns = []

export { render, staticRenderFns }